import React from 'react';
import { useBusinessContext } from '../contexts/BusinessContext';
import { staticData, motivationalMessages } from '../data/staticData';
import './CountryDetailsDialog.css';

export function CountryDetailsDialog() {
  const { 
    isCountryDetailsDialogOpen, 
    closeCountryDetailsDialog, 
    businessDetails,
    openDialog,
    openPricingDialog,
    setCurrentMessage
  } = useBusinessContext();

  const handleBackToSelection = () => {
    closeCountryDetailsDialog();
    openDialog();
  };

  const handleContinue = () => {
    setCurrentMessage(motivationalMessages.planSelected);
    closeCountryDetailsDialog();
    openPricingDialog();
  };

  if (!isCountryDetailsDialogOpen || !businessDetails) return null;

  const countryData = staticData.countries.find(c => c.code === businessDetails.countryCode) || staticData.countries.find(c => c.code === 'GL');

  return (
    <div className="country-details-overlay" onClick={closeCountryDetailsDialog}>
      <div className="country-details-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="country-details-header">
          <button className="country-details-back" onClick={handleBackToSelection}>
            ←
          </button>
          <button className="country-details-close" onClick={closeCountryDetailsDialog}>
            ×
          </button>
        </div>

        <div className="country-details-content">
          <div className="country-details-flag-section">
            <div className="country-details-flag-large">
              <span className="country-flag-emoji-large">{countryData?.flag}</span>
            </div>
            <h2 className="country-details-title">{countryData?.name}</h2>
            <p className="country-details-subtitle">{countryData?.subtitle}</p>
          </div>

          <div className="country-details-info">
            <p className="country-details-description">{countryData?.description}</p>
            
            <div className="country-details-stats">
              <div className="country-stat-item">
                <span className="country-stat-label">Population</span>
                <span className="country-stat-value">{countryData?.population}</span>
              </div>
              <div className="country-stat-item">
                <span className="country-stat-label">GDP</span>
                <span className="country-stat-value">{countryData?.gdp}</span>
              </div>
              <div className="country-stat-item">
                <span className="country-stat-label">Growth Rate</span>
                <span className="country-stat-value">{countryData?.growthRate}</span>
              </div>
              <div className="country-stat-item">
                <span className="country-stat-label">Currency</span>
                <span className="country-stat-value">{countryData?.currency}</span>
              </div>
            </div>
          </div>

          <button className="country-details-continue" onClick={handleContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

